var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"search-options":{
      enabled: true,
      //trigger: 'enter',
      skipDiacritics: true,
      //searchFn: mySearchFn,
      placeholder: 'Buscar en la tabla',
      //externalQuery: searchQuery
    },"sort-options":{
      enabled: true,
      initialSortBy: { field: 'sensor', type: 'asc' },
    },"pagination-options":{
      enabled: true,
      mode: 'records',
      perPage: 10,
      dropdownAllowAll: false,
      //setCurrentPage: 2,
      nextLabel: '',
      prevLabel: '',
      rowsPerPageLabel: 'Filas por pagina',
      ofLabel: 'de',
      pageLabel: 'pagina', // for 'pages' mode
      allLabel: 'Todas',
    }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return undefined}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }